import { useState } from "react"

import { parseErrorAsObj } from "../../../../errors/errorProcessors"
import { IAppError } from "../../../../errors/errorTypes"
import { deleteClientProtected } from "../../clients/clients"
import { DNO_DELETE_COMMENT, INSTALLER_DELETE_COMMENT } from "../../urls/hybrid"

interface IDeleteApplicationCommentHook {
    isSending: boolean
    error: IAppError | undefined
    postResponse: (
        applicationId: string,
        commentId: string,
        isDno: boolean
    ) => Promise<void>
}

const useDeleteApplicationComment = (): IDeleteApplicationCommentHook => {
    const [isSending, setIsSending] = useState(false)
    const [error, setError] = useState<IAppError | undefined>(undefined)

    const postResponse = async (
        applicationId: string,
        commentId: string,
        isDno: boolean
    ): Promise<void> => {
        try {
            let url
            setIsSending(true)
            if (isDno) {
                url = DNO_DELETE_COMMENT(applicationId, commentId)
            } else {
                url = INSTALLER_DELETE_COMMENT(applicationId, commentId)
            }
            await deleteClientProtected(url)
        } catch (err) {
            const errorObj = parseErrorAsObj(err)
            setError(errorObj)
        } finally {
            setIsSending(false)
        }
    }

    return {
        error,
        isSending,
        postResponse,
    }
}

export default useDeleteApplicationComment
